import { CommonModule         } from "@angular/common";
import { Component            } from "@angular/core";
import { ReactiveFormsModule  } from "@angular/forms";
import { SidebarModule        } from 'primeng/sidebar';
import { DropdownModule       } from "primeng/dropdown";

import { CcBaseSidebar        } from "nv@components/cc-sidebar/cc-sidebar.base";
import { CcSidebar            } from "nv@components/cc-sidebar/cc-sidebar.component";
import { TranslatePipe        } from "nv@services/translate.service";

@Component({
  selector    : 'sidebar-manage-reports',
  templateUrl : './manage-reports.component.html',
  styleUrl    : './manage-reports.component.scss',
  imports     : [
    ReactiveFormsModule ,
    CommonModule        ,
    SidebarModule       ,
    SidebarModule       ,
    CcSidebar           ,
    DropdownModule      ,
    TranslatePipe
  ]
})
export class SidebarManageReports extends CcBaseSidebar {

  public sidebarTitle  = 'Download Report';
}
